import { Component, ChangeDetectionStrategy } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { DateTime } from "luxon";
import { TimelineModule } from "@openng/optimus-ui/timeline";
@Component({
  standalone: true,
  selector: "app-version-info",
  imports: [TimelineModule, TranslateModule],
  templateUrl: "./version-info.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./version-info.component.scss",
})
export class VersionInfoComponent {
  public versions = [
    {
      versionNumber: "2.5.0",
      detailsIndex: 9,
      releaseDate: 1772578800000,
    },
    {
      versionNumber: "2.4.2",
      detailsIndex: 8,
      releaseDate: 1769446800000,
    },
    {
      versionNumber: "2.4.1",
      detailsIndex: 7,
      releaseDate: 1765540800000,
    },
    {
      versionNumber: "2.4.0",
      detailsIndex: 6,
      releaseDate: 1763661600000,
    },
    {
      versionNumber: "2.3.0",
      detailsIndex: 5,
      releaseDate: 1759356000000,
    },

    {
      versionNumber: "2.2.0",
      detailsIndex: 4,
      releaseDate: 1755292555000,
    },
    {
      versionNumber: "2.1.0",
      detailsIndex: 3,
      releaseDate: 1749840173000,
    },
    {
      versionNumber: "2.0.0",
      detailsIndex: 2,
      releaseDate: 1725235200000,
    },
    {
      versionNumber: "1.1.0",
      detailsIndex: 1,
      releaseDate: 1701993600000,
    },
    {
      versionNumber: "1.0.0",
      detailsIndex: 0,
      releaseDate: 1681689600000,
    },
  ];

  public convertToDate(ms: number) {
    return DateTime.fromMillis(ms).toFormat("dd.MM.yyyy");
  }
}
